<template>
  <el-dialog :close-on-click-modal="false" :visible="visible"
             :title="$t('qu-xiao-yu-yue')"
             :modal-append-to-body='false' @close="close">
    <el-form :model="form"
             ref="form"
             :label-width="formLabelWidth"
             >
      <!--是否扣分 cencelIsDeduct-->
      <!--取消说明 cencelRemarks-->
      <el-form-item :label="$t('shi-fou-kou-fen')" prop="cencelIsDeduct">
        <el-switch active-value="Y"
                   inactive-value="N"
                   v-model="form.cencelIsDeduct"></el-switch>
      </el-form-item>
      <el-form-item :label="$t('qu-xiao-shuo-ming')" prop="cencelRemarks">
        <el-input :placeholder="defaultCencelRemarks" :style="{width: '80%'}"
                  v-model="form.cencelRemarks" maxlength="50" show-word-limit></el-input>
      </el-form-item>
    </el-form>
     <!--footer -->
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" plain @click="clearForm">{{ $t('qu-xiao') }}</el-button>
      <el-button size="mini" plain type="primary" @click.native="submit" :loading="loading">{{ $t('ti-jiao') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "cancel",
    components: {},
    props: {
      visible: false,
      loading: false,
      id: {
        type: Number,
        required: true
      },
    },
    data() {
      return {
        type: 'cancel',
        form: {},
        defaultCencelRemarks: this.$t('yun-ying-shang-hou-tai-qu-xiao'),
        formLabelWidth: '100px'
      }
    },
    methods: {
      clearForm() {
        this.form.cencelIsDeduct = 'N'
        this.form.cencelRemarks = ''
        this.$emit('close', this.type)
      },
      submit() {
        if(!this.form.cencelRemarks || this.form.cencelRemarks === '') {
          this.form.cencelRemarks = this.defaultCencelRemarks
        }
        this.form.id = this.id
        console.log(this.form)
        this.$emit('submit', this.form)
      },
      close() {
        this.$emit('close', this.type)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentRecords/cancel.vue